import clsx from 'clsx';
import type * as React from 'react';

import {
    BLOCK_LIST_OL,
    BLOCK_LIST_TASKS,
    BLOCK_LIST_UL,
    type BlockListItemData,
} from '@gitbook/doc-core';
import type { BlockProps } from '@gitbook/slate-react';
import { Icon } from '@gitbook/spine-icons';

import { CheckBox } from '../../Form';
import { usePlainMarkdownStyle } from '../usePlainMarkdownStyle';
import { BasicBlockWrapper } from './BasicBlockWrapper';

/*
 * Basic renderer for a list item block.
 */
export function BasicBlockListItem(props: BlockProps): React.ReactElement {
    const { node, parent, children, editor } = props;
    const { readOnly } = editor;

    const { textStyle } = usePlainMarkdownStyle();

    const data = node.data.toFrozenObject() as BlockListItemData;
    const isUL = parent.type === BLOCK_LIST_UL;
    const isOL = parent.type === BLOCK_LIST_OL;
    const isTask = parent.type === BLOCK_LIST_TASKS;

    return (
        <BasicBlockWrapper tag="li" className="relative flex items-baseline" {...props}>
            {isTask && (
                <span contentEditable={false} className="flex shrink-0 px-2">
                    <CheckBox
                        value={Boolean(data.checked)}
                        onValueChange={() => {}}
                        readOnly={readOnly}
                        size={18}
                    />
                </span>
            )}
            {isUL && (
                <span contentEditable={false} className="flex shrink-0 px-2">
                    <Icon.Dot size={12} className={textStyle} />
                </span>
            )}
            {isOL && (
                <span
                    contentEditable={false}
                    className={clsx('flex shrink-0 px-2 text-ui-base', textStyle)}
                >
                    {parent.getChildIndex(node.key) + 1}.
                </span>
            )}

            <span className="flex-1">{children}</span>
        </BasicBlockWrapper>
    );
}
